import { ProductDetailsBenefitCategorySelectorEnum } from '../../../types/cmsEnums';
import { CmsProduct } from '../../../types/cmsProduct';
import { getProductBenefitCategories } from './getProductBenefitCategories';

/**
 * Which benefit categories the ProductDetails modal renders (CMS-1924).
 *
 * For the `#usePDP`-marker modal the canonical PDP page's filter wins, then the
 * block's own, and if neither is configured every category the product carries
 * — the marker modal must not silently hide Benefits.
 *
 * Every other modal keeps the editor-configured value verbatim, unset included:
 * an unset selector hides Benefits there, exactly as it did before CMS-1924.
 *
 * A cleared Strapi multi-select comes back as `[]`, which means "not
 * configured" rather than "hide every category" — hence the length checks.
 */
export const resolveModalBenefitCategorySelector = ({
  usePdp,
  pdpPageSelector,
  editorConfiguredSelector,
  product,
}: {
  usePdp: boolean;
  pdpPageSelector?: ProductDetailsBenefitCategorySelectorEnum[];
  editorConfiguredSelector?: ProductDetailsBenefitCategorySelectorEnum[];
  product?: CmsProduct;
}): ProductDetailsBenefitCategorySelectorEnum[] | undefined => {
  if (!usePdp) {
    return editorConfiguredSelector;
  }
  if (pdpPageSelector?.length) {
    return pdpPageSelector;
  }
  if (editorConfiguredSelector?.length) {
    return editorConfiguredSelector;
  }
  return getProductBenefitCategories(product);
};
